<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading">
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">发货单ID：</span>
              {{ detail.order_id }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">发货单号：</span>
              {{ detail.order_no }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户信息：</span>
              {{ detail.user.nickName }}
              <span>用户ID：({{ detail.user.user_id }})</span>
            </div>
          </el-col>

        </el-row>
      </div>


      <!--收货信息-->
      <div>
        <div class="common-form mt16">收货信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货人：</span>
                {{ detail.name }}
              </div>
            </el-col>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货电话：</span>
                {{ detail.phone }}
              </div>
            </el-col>
            <el-col :span="10">
              <div class="pb16">
                <span class="gray9">收货地址：</span>
                {{ detail.address }}
              </div>
            </el-col>
          </el-row>

        </div>
      </div>

      <div>
        <div class="common-form mt16">发货单状态 <span class="green">{{ detail.order_status.text }}</span></div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">订单类型：</span>
                <span class="blue">{{ detail.pick_type.text }}</span>
              </div>
            </el-col>
            <el-col :span="10" v-if="detail.pick_type.value == 20">
              <div class="pb16">
                <span class="gray9">取货地址：</span>
                {{ detail.pick_address }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.pick_type.value == 10">
              <div class="pb16">
                <span class="gray9">拣货状态：</span>
                <span class="red">{{ detail.picking_status.text }}</span>
              </div>
              <div class="pb16" v-if="detail.pick_type.value == 10 && detail.picking_status.value == 20">
                <span class="gray9">拣货时间：</span>
                {{ detail.picking_time }}
              </div>
            </el-col>

            <el-col :span="5" v-if="detail.pick_type.value == 10 && detail.picking_status.value == 20">
              <div class="pb16">
                <span class="gray9">拣货数量：</span>
                {{ detail.picking_number }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.pick_type.value == 10 && detail.picking_status.value == 20" >
              <div class="pb16">
                <span class="gray9">拣货体积：</span>
                {{ detail.picking_volume }}
              </div>

            </el-col>
          </el-row>
          <el-row v-if="detail.picking_status.value == 20">
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">派单状态：</span>
                <span class="green">{{ detail.assign_status.text }}</span>
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.assign_status.value == 20">
              <div class="pb16">
                <span class="gray9">派单时间：</span>
                {{ detail.assign_time }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.assign_status.value == 20">
              <div class="pb16">
                <span class="gray9">派送员ID：</span>
                {{ detail.assign_user_id }} (昵称：{{ detail.assignUser.nickName }};姓名：{{detail.assignUser.distribution.real_name}};联系方式：{{detail.assignUser.distribution.mobile}})


              </div>
            </el-col>
          </el-row>
          <el-row v-if="detail.assign_status.value == 20">
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">取货状态：</span>
                <span class="green">{{ detail.take_status.text }}</span>
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.take_status.value == 20">
              <div class="pb16">
                <span class="gray9">取货时间：</span>
                {{ detail.take_time }}
              </div>
            </el-col>

          </el-row>
          <el-row v-if="detail.take_status.value == 20">
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">收货状态：</span>
                <span class="green">{{ detail.receipt_status.text }}</span>
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.receipt_status.value == 20">
              <div class="pb16">
                <span class="gray9">收货时间：</span>
                {{ detail.receipt_time }}
              </div>
            </el-col>
            <el-col :span="5" v-if="detail.receipt_status.value == 20">
              <div class="pb16">
                <span class="gray9">收货验收单：</span>
                <div class="pic">
                    <el-image
                       style="width: 100px; height: 80px"
                       :src="detail.image.file_path"
                       :preview-src-list="[detail.image.file_path]">
                    </el-image>
                 </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>










    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>

    </div>
  </div>
</template>

<script>
  import DistributionApi from '@/api/distribution.js';

  import {
    deepClone
  } from '@/utils/base.js';
  export default {
    components: {

    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          pay_status: [],
          pay_type: [],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          order_status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: []
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          is_cancel: 1
        },
        extract_form: {
          order: {
            extract_status: 1
          }
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        /*快递公司列表*/
        expressList: [],
        shopClerkList: [],
        /*是否打开编辑弹窗*/
        open_edit: false
      };
    },
    created() {
      /*获取列表*/
      this.getParams();
    },
    methods: {
      next() {
        if (this.active++ > 4) this.active = 0;
      },
      /*获取参数*/
      getParams() {
        let self = this;
        // 取到路由带过来的参数
        const params = this.$route.query.order_id;
        DistributionApi.pickOrderDetail({
              order_id: params
            },
            true
          )
          .then(data => {
            self.loading = false;
            self.detail = data.data.detail;
            self.expressList = data.data.expressList;
            self.shopClerkList = data.data.shopClerkList;
          })
          .catch(error => {
            self.loading = false;
          });
      },


      /*打开编辑*/
      editClick(item) {
        this.userModel = deepClone(item);
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          this.getParams();
        }
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/distribution/picking/detail.vue